import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (user && typeof user === "object") navigate("/admin", { replace: true });
  }, [user, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email.trim().toLowerCase(), password);
    setLoading(false);
    if (res.ok) {
      toast.success("Bienvenida");
      navigate("/admin", { replace: true });
    } else {
      setError(res.error || "Credenciales inválidas");
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen bg-cream flex items-center justify-center px-6"
    >
      <div className="w-full max-w-md">
        <p className="text-terracotta text-xs uppercase tracking-[0.3em] mb-3 text-center">
          Mujeres Motor · Admin
        </p>
        <h1 className="font-serif text-4xl text-charcoal text-center mb-10 font-light">
          Ingresa a tu <span className="italic">estudio</span>
        </h1>

        <form
          onSubmit={onSubmit}
          data-testid="admin-login-form"
          className="bg-white p-8 md:p-10 rounded-sm border border-charcoal/10 space-y-5"
        >
          <div>
            <label className="text-xs uppercase tracking-widest text-charcoal/60 block mb-2">
              Correo
            </label>
            <input
              data-testid="login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-charcoal/20 rounded-sm px-4 py-3 focus:border-terracotta focus:outline-none"
              placeholder="admin@mujeres-motor.com"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-charcoal/60 block mb-2">
              Contraseña
            </label>
            <input
              data-testid="login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-charcoal/20 rounded-sm px-4 py-3 focus:border-terracotta focus:outline-none"
              placeholder="••••••••"
            />
          </div>

          {error && (
            <p data-testid="login-error" className="text-sm text-destructive">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full btn-primary disabled:opacity-60"
          >
            {loading ? "Ingresando…" : "Ingresar"}
          </button>
        </form>
      </div>
    </div>
  );
}
